var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Dominica") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 600,
    width: 1200,
    fill: "#006b3f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 600,
    x: 525,
    fill: "#fcd116"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 75,
    y: 225,
    fill: "#fcd116"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 600,
    x: 600,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 75,
    y: 300,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 600,
    x: 575,
    fill: "#000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 50,
    y: 275,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#006b3f",
    transform: "translate(600,300)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 150,
    fill: "#d41c30"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star",
    stroke: "#000",
    d: "m-4.81,-118.41 4.81,-13.72 4.37,13.5 14.65,0.22 -11.59,8.85 5.25,15.05 -12.68,-9.29 -12.46,8.85 4.81,-14.61 -11.37,-8.63 14.21,-0.22z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star2",
    transform: "rotate(36)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star2",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star2",
    transform: "rotate(108)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star2",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 680.21,
    cy: 586.13,
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(0.289553,-0.03018225,0.01658794,0.23225804,-186.11735,-75.926206)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 680.21,
    cy: 586.13,
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(0.30625538,-0.03184484,0.01668502,0.23224838,-188.73313,-74.886801)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 680.21,
    cy: 586.13,
    rx: 30.805,
    ry: 189.82,
    transform: "matrix(0.24500433,-0.0258909,0.01789798,0.25675005,-151.94706,-90.935577)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a00",
    strokeWidth: 0.6573,
    d: "m-44.213085,62.564681c7.657331,-0.318514 4.332103,-4.415732 8.199242,-6.595651 3.864538,-2.177268 9.365358,-0.736785 11.015564,1.985834 1.650207,2.72262 0.327013,5.396731 2.450471,5.433299 2.12601,0.03661 59.928115,-2.387638 62.010231,-0.105265 2.084719,2.27972 2.428307,6.775972 0.269442,8.524141 -2.159263,1.769736 -75.234738,2.587907 -77.751167,0.737649 -2.516925,-1.823297 -6.202071,-9.529768 -6.193783,-9.980007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 0.6326,
    d: "M-3.3768912,68.194919C-3.5157446,73.97045 5.0266835,72.334565 5.1440072,77.158287 4.886691,82.271863 -9.1802916,77.470843 -9.3156063,68.11661 -8.7307374,58.771874 5.0382371,54.154377 5.208533,59.491796c0.1266662,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 0.6326,
    d: "M1.6637058,68.261384C1.5248524,74.036915 10.067281,72.40103 10.184604,77.224752 9.927288,82.338328 -4.1396946,77.537308 -4.2750093,68.183075 -3.6901404,58.838339 10.078834,54.220842 10.24913,59.558261c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 0.6326,
    d: "M7.0709208,68.057753C6.9320674,73.833284 15.474496,72.197399 15.591819,77.021121 15.334503,82.134697 1.2675204,77.333677 1.1322057,67.979444 1.7170746,58.634708 15.486049,54.017211 15.656345,59.35463c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 0.6326,
    d: "m12.111394,68.124255c-0.138854,5.775532 8.403575,4.139646 8.520898,8.963369C20.374976,82.2012 6.3079934,77.40018 6.1726787,68.045947 6.7575476,58.701211 20.526522,54.083714 20.696818,59.421133c0.126666,4.435124 -8.446571,2.927591 -8.585424,8.703122z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9c4a00",
    strokeWidth: 0.3991,
    cx: 478.38,
    cy: -41.085999,
    rx: 3.5339,
    ry: 3.4030001,
    transform: "matrix(1.3799165,0.02078085,-0.03061721,1.4544413,-625.22695,117.20523)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-119.97806,-293.41566)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-127.33463,-293.99555)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20742248,-0.0312918,0.04226106,0.39513549,-132.603,-303.41129)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.19942957,-0.0315355,0.04632234,0.43592867,-125.4075,-340.63478)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-112.65072,-316.23218)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-118.30405,-319.63879)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-125.43742,-324.55362)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-132.04249,-327.53171)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.5749,
    d: "m-14.73408,-52.686013c0,0 -14.655341,12.719161 -13.010831,47.1436528 1.845436,34.6199222 32.3934914,50.8943372 32.3934914,50.8943372 0,0 7.7859806,-9.826932 6.8819576,-37.6434978C9.3473299,-32.960001 -5.0778778,-50.928723 -5.0778778,-50.928723l-9.6562022,-1.75729z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-45.183498,-309.40147)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-52.318928,-311.28321)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20967854,0.00617736,-0.02883913,0.39634115,-55.824816,-321.48715)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.20185704,0.00451301,-0.03211329,0.43720504,-42.110313,-356.83224)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-33.906971,-330.54675)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-38.862639,-334.90639)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-45.005838,-341.01389)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 427.11,
    cy: 905,
    rx: 20.814,
    ry: 24.144,
    transform: "matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-50.974388,-345.12149)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#d41c30",
    strokeWidth: "1pt",
    cx: 624.42,
    cy: 606.11,
    rx: 58.28,
    ry: 186.49,
    transform: "matrix(0.19786701,-0.07643491,0.08023488,0.18709671,-155.83813,-59.21337)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.4635,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-99.510833,-162.76931)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5462,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-84.135444,-169.29958)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5462,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-90.652069,-169.41561)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.56,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-93.887858,-166.3691)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.56,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-94.461639,-172.01688)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5462,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-96.8782,-173.22007)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5623,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-95.468785,-176.63136)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.4635,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-114.72518,-179.36983)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.56,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-98.157196,-179.08115)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5623,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-100.2913,-183.52126)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5462,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-110.48856,-178.90566)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5623,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-108.8569,-179.77161)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.5623,
    cx: 218.13,
    cy: 356.75,
    rx: 10.823,
    ry: 12.905,
    transform: "matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-106.80676,-183.69602)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 2.5449,
    cx: 528.68,
    cy: 564.48,
    rx: 67.438,
    ry: 205.64,
    transform: "matrix(0.21931516,-0.07742835,0.08682875,0.20202384,-145.01539,-72.55561)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.20574399,-0.0978521,0.09471329,0.21196041,-137.12211,-77.403485)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "M31.462582,7.798675C44.273286,23.396889 42.655575,33.30197 41.319929,41.68219 37.295042,32.018935 35.09747,25.935914 22.284544,10.334996 9.4716187,-5.2659225 15.867064,-16.212552 16.746886,-21.981169c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "M32.616052,20.397765C45.426756,35.995979 43.809045,45.90106 42.473399,54.28128 38.448512,44.618025 36.25094,38.535004 23.438014,22.934086 10.625089,7.3331675 17.020534,-3.6134618 17.900356,-9.382079c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "M33.001502,30.545466C46.121623,45.867895 44.702257,55.805012 43.534416,64.211635 39.317096,54.636146 36.998322,48.601234 23.875927,33.276148 10.753531,17.951062 16.928895,6.8711542 17.693213,1.0852029 19.719255,6.0361835 19.879107,15.22038 33.001502,30.545466z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.3887,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.40784061,-0.1037946,0.16693789,0.37767112,-299.57061,-196.0302)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.6398,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.36689221,-0.0631048,0.12978287,0.31264984,-259.00282,-166.87124)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.6398,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.36814797,-0.0553158,0.1232589,0.31530969,-261.52366,-166.81962)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 2.0966,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.29657862,-0.05431058,0.11151259,0.23307633,-211.06958,-135.53834)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 2.0966,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.27027,-143.86531)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "M8.6195396,-15.767835C12.407426,-6.5127711 13.940854,1.8088668 12.039861,2.8095164 10.141163,3.8089573 5.5266551,-2.8908549 1.7387689,-12.145919"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 2.0966,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.89375,-154.73721)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 2.0966,
    cx: 528.68,
    cy: 646.07,
    rx: 13.321,
    ry: 40.796,
    transform: "matrix(0.30032211,-0.03210428,0.09144035,0.24056268,-212.194,-155.98718)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "m2.0257453,-28.338145c3.6779608,6.253928 5.6581289,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "m4.5726443,-32.485105c3.6779608,6.253928 5.6581287,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "m16.013433,-31.606808c5.124964,8.542601 7.882604,16.520579 6.153303,17.810625 -1.727212,1.288488 -7.287655,-4.598619 -12.4126197,-13.14122"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5749,
    d: "m8.4524006,-36.082328c3.6926974,6.904591 5.6865404,13.348237 4.4490124,14.385262 -1.236034,1.035772 -5.2356299,-3.727092 -8.9283268,-10.631682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.5905,
    d: "m8.1245845,-46.086178c-2.4652011,2.482234 -0.05083,7.123595 2.2055225,8.801039 2.530629,2.294221 16.742134,17.286089 26.768781,4.672222C29.06535,-32.759025 14.072204,-51.617449 8.1245845,-46.086178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.5905,
    d: "m6.3689905,-53.485518c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306289,2.294221 16.7421339,17.286089 26.7687809,4.672222C27.309756,-40.158365 12.31661,-59.016789 6.3689905,-53.485518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.5905,
    d: "m4.1226915,-60.575768c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.026684,-19.004532 -28.9743035,-13.473261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.5905,
    d: "m-0.75854747,-68.686568c-2.46520113,2.482234 -0.0508299,7.123595 2.20552257,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.0266836,-19.004532 -28.97430347,-13.473261z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9461c9",
    strokeWidth: 0.6276,
    d: "m-18.271949,-76.448224c5.080302,-3.778951 14.4116525,-4.884005 21.6814205,-1.183186 6.0553769,2.966807 16.1473035,15.072925 23.7340285,17.934947 -5.339994,0.952539 -8.588551,0.147731 -12.001308,-1.491593 -6.7388646,4.879721 -9.1401688,5.611298 -16.00788077,6.570161 -9.55160223,1.377954 -17.47968323,-1.108557 -20.26606523,-6.089426 -2.839252,-4.699505 -1.61543,-12.238734 2.859805,-15.740903z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#d41c30",
    cx: 287.23,
    cy: 323.04,
    rx: 14.154,
    ry: 14.986,
    transform: "matrix(0.30909157,0.00550335,-0.00301489,0.16932914,-95.304017,-125.19072)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fcd116",
    cx: 204.58,
    cy: 348.26,
    rx: 23.254,
    ry: 15.895,
    transform: "matrix(0.24579207,-0.09143683,0.08132205,0.2192462,-99.445497,-116.289)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    stroke: "none",
    cx: 283.9,
    cy: 333.86,
    rx: 5.828,
    ry: 5.8279,
    transform: "matrix(0.26990081,0.00480556,-0.00415607,0.23342269,-82.956029,-148.37388)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    strokeWidth: 0.7318,
    d: "m-17.127905,-65.514747c0.402078,1.948925 -1.043505,4.582316 -4.180015,5.515002 -3.195207,1.322722 -5.618416,4.322017 -7.016075,9.226342 -4.855803,-11.183796 -1.769609,-15.915544 3.387899,-17.06567 4.436579,-1.414945 7.11029,-1.235679 7.808191,2.324326z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    stroke: "none",
    cx: 198.98,
    cy: 362.39,
    rx: 4.7097,
    ry: 4.7097,
    transform: "matrix(0.23597119,-0.0123552,0.01333585,0.24161486,-73.600709,-149.7658)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.4ffb65574a5d638206edcc7dd9433979.svg";
export { ForwardRef as ReactComponent };